export default {
  title: "Пропуска",
  availableAmount: "Доступно еще {amount}",
  makePass: "Оформить",
  untilDeadline: "Не позднее {date}",
  downloadNotification: "Теперь вы можете скачать пропуска",
  downloadTooltip: "Скачать/распечатать",
  processedStatus: "Обрабатывается",
  errorBarcodeStatusShort: "Ошибка",
  errorVisaPass: "Отменен",
  errorBarcodeStatus: "Ошибка генерации пропуска",

  participantPasses: "Удостоверения участников",
  carPasses: "Разовый автомобильный пропуск",
  mountingPasses: "Пропуск на монтаж/демонтаж",

  outOf: "{amount} из {total}",

  subexpPart1: "Распределите пропуска",
  subexpPart2: "здесь",

  packageTitle: "Пакетная загрузка пропусков",
  packageDescription:
    "Для заказа пропусков вы также можете воспользоваться пакетной загрузкой данных. Заполните бланк документа и загрузите.",

  packageTitle__Participant: "Пакетная загрузка удостоверений участников",
  packageDescription__Participant:
    "Для заказа удостоверений участника вы также можете воспользоваться пакетной загрузкой данных. Заполните бланк документа и загрузите.",

  packageTitle__Montage: "Пакетная загрузка пропусков",
  packageDescription__Montage:
    "Для заказа пропусков вы также можете воспользоваться пакетной загрузкой данных. Заполните бланк документа и загрузите.",

  packageDownloadBlank: "Скачать бланк",
  packageUploadFile: "Загрузить файл",

  addPass: "Добавить пропуск",
  deleteAll: "Удалить все",
  reload: "Обновить",

  deleteAllPopup: "Вы уверены, что хотите удалить все пропуска?",
  deletePassPopup:
    "Вы точно хотите удалить данный пропуск? Удаленный пропуск будет заблокирован!",

  deadlineReachedAndNoPasses: `
    Возможность оформить пропуска через Личный кабинет завершена. <br />
    К сожалению, Вы не уложились в обозначенный срок оформления пропусков.  <br />
    
    <br /><br />
    
    Благодарим за понимание.
  `,

  printNote: `
      Функция печати пропусков (удостоверения участника и пропуска на
      монтаж/демонтаж для самозастройщиков) открывается за 3 дня до первого дня
      монтажа.
  `,

  errors: {
    invalid_or_empty_document: "Бланк пропусков пуст или некорректен",
    file_upload_error: "Ошибка загрузки файла на сервер",
    quota_reached: "Вы превысили выделенную квоту на пропуска",
    date_validation_error:
      'Проверьте корректность заполнения поля "Дата рождения".',
    fields_validation_error:
      "Проверьте правильность заполнения полей: {fields}",
    validation_errors: "Проверьте правильность заполнения полей в строках",
    default: "Серверная ошибка"
  },
  sort: {
    by_date_asc: "по дате добавления (новые)",
    by_date_desc: "по дате добавления (старые)",
    by_name_asc: "по фамилии (A-Я)",
    by_name_desc: "по фамилии (Я-А)"
  },
  qr: {
    uploadQR: "Загрузить QR-код",
    downloadedQR: "QR-код загружен",
    noDownloadedQR: "Отклонен или не загружен",
    errorNoDownloadedQR: "QR-код не загружен",
    changeBtn: "Изменить",
    errorSize:
      "Файл слишком большой ({filesize}). Максимальный размер файла: {maxFilesize}Mb.",
    errorAccepted:
      "Ошибка загрузки файла: допустимые форматы файлов - PDF, JPG, JPEG",
    titlePassesNoUpload: "QR-код вакцинированного/переболевшего",
    titlePassesUpload: "QR-код",
    notePasses: "Обратите внимание!",
    stepPasses1: "Изображение QR-кода должно быть четким.",
    stepPasses2:
      "Файл должен быть в формате PDF или JPG, размером не более 5Мб.",
    downloadFile: "Скачать файл",
    linkCertificate: "Ссылка на&nbsp;сертификат",
    requiredField: "Обязательное поле",
    tryAgain: "Попробовать снова",
    backBtn: "Назад",
    codeSuccessfullyScanned: "Ваш код успешно отсканирован.",
    pointCameraQRCode: "Пожалуйста, наведите камеру на QR-код.",
    errorQRScannerHTTPS:
      "Доступ к камере разрешен только по протоколу передачи данных HTTPS.",
    errorQRScannerStreamApi: "Stream API не поддерживается в этом браузере.",
    errorQRScannerOverconstrainedError: "Установленная камера не подходит",
    errorQRScannerNotReadableError: "Камера уже используется.",
    errorQRScannerNotSupportedError: "Незащищенное соединение.",
    errorQRScannerNotFoundError: "У вас нет камеры.",
    errorQRScannerNotAllowedError:
      "Вы запретили доступ к камере, разрешите доступ в настройках вашего браузера.",
    downloadQRCodePDF: "Загрузите файл сертификата в формате PDF",
    downloadQRCodeImageJPG: "Или загрузите изображение QR-кода в формате JPG",
    downloadCertificate: "Загрузить сертификат",
    scanQRCode: "Сканировать QR-код",
    chooseDownloadQRCOde: "Выберите способ загрузки QR-кода",
    scanQRCodeWithCamera:
      "Отсканируйте изображение QR-кода с использованием камеры вашего устройства."
  },

  participant: {
    warningPass:
      "Не забудьте распечатать или сохранить на телефон оформленные удостоверения участника! Используйте их для прохода на входных турникетах AO «ЭКСПОЦЕНТР».\n",
    downloadBlank: "/static/pass-template/participant-template.xlsx",
    deadlinesText: "Проведение выставки: {from} — {to}.",
    quotaText:
      "Если Вам необходимо заказать дополнительные удостоверения участников сверх квоты за дополнительную плату, обратитесь в Сервис Бюро, тел. +7 499 428-03-00, e-mail: pass@expocentr.ru",

    addTitle: "Добавить удостоверение участника",
    applicationTitle: "Заявка на удостоверение",

    companyName: "Название компании для пропуска",

    birthdayPlaceholder: "ДД.ММ.ГГГГ",
    birthplacePlaceholder: "Как в паспорте",

    packageUploadSize: "xlsx, 12 КБ",
    warningMessage:
      "Функция печати удостоверений участника открывается {date}г.",
    chooseCitizenship: " Укажите гражданство",
    citizenship: "Гражданство",
    eVisaInfo:
      "Единая электронная виза (E-Visa) дает Вам право на въезд и пребывание в РФ с частным или деловым визитом, туризмом и действительна в течение 16 дней с даты въезда. Заявителям на получение E-Visa не требуется письмо-приглашение.",
    visaInfo:
      "Удостоверения участника с оформленным приглашением на въезд в РФ нельзя распечатать из Личного кабинета.\n" +
      "После получения приглашения на въезд в РФ и приезда на выставку, обратитесь в Сервис-бюро АО «ЭКСПОЦЕНТР» для получения «Удостоверения участника» лично под подпись, при предъявлении документа, удостоверяющего личность.\n",
    isVisaInvite: "Оформить приглашение на въезд в РФ",
    visaHelp1: "Есть вопросы?",
    visaHelp2: "Обратитесь к специалисту Отдела протокола:",
    visaSimpleInfo1:
      "В случае если Заявитель является гражданином страны, в отношении которой действует соглашение об упрощении выдачи виз, Приглашение выдается АО «ЭКСПОЦЕНТР».",
    visaSimpleInfo2:
      " Оформление данного Приглашения входит в стоимость участия в выставочном мероприятии.",
    visaSimpleInfo3:
      " Оформление Приглашения может потребовать до 5 (пяти) рабочих дней после получения Запроса, содержащего всю необходимую информацию",
    visaNotSimpleInfo1:
      "В случае если Заявитель является гражданином страны, в отношении которой не действует соглашение об упрощении выдачи виз, Приглашение выдается Управлением по вопросам миграции ГУ МВД России по г. Москве.",
    visaNotSimpleInfo2:
      "Оформление Приглашения оплачивается в соответствии со Ставками за услуги экспонентам на выставках, проводимых АО «ЭКСПОЦЕНТР», действующими на момент выставления счета.",
    visaNotSimpleInfo3:
      "Оформление Приглашения в Управлении по вопросам миграции ГУ МВД России по г. Москве может потребовать до 25 (двадцати пяти) рабочих дней после получения оплаты и подачи документов",
    visaAverageLateNotification:
      "К сожалению, слишком поздно обращаться за официальным приглашением, выданным Управлением по вопросам миграции МВД России в Москве. Процесс оформления занимает до 50 дней.",
    visaSimpleLateNotificationL:
      "К сожалению, слишком поздно обращаться за официальным приглашением, выданным АО «ЭКСПОЦЕНТР». Процесс оформления занимает до 5 дней.",
    visaPassApplied:
      "Обратитесь в Сервис Бюро АО «ЭКСПОЦЕНТР» для получения «Удостоверения участника выставки» лично под подпись, при предъявлении документа, удостоверяющего личность.",
    visaPassAppliedContacts: "Тел. +7 499 428-03-00, e-mail: pass@expocentr.ru",
    visaPassRejected:
      "Заявителям на получение E-Visa не требуется письмо-приглашение. ",
    visaPassRejected2:
      "Или слишком поздно обращаться за официальным приглашением, выданным АО «ЭКСПОЦЕНТР». Процесс оформления занимает до {amount} дней."
  },

  car: {
    rulesTitle: "Правила ввоза и вывоза оборудования и экспонатов",
    warningAutoPass:
      "Не забудьте распечатать или сохранить на телефон оформленные авто пропуска! Предъявите сотруднику охраны въездного поста оформленный авто пропуск для заезда на территорию AO «ЭКСПОЦЕНТР».",
    addTitle: "Добавить разовый автомобильный пропуск",
    carApplicationTitle: "Заявка на разовый автомобильный пропуск",
    driverApplicationTitle: "Информация о водителе",
    cargoApplicationTitle: "Информация о грузе",

    govVehicleNumber: "Гос. номер ТС",
    govTrailerNumber: "Гос. номер прицепа",
    arrivalDate: "Дата заезда",
    departureDate: "Дата выезда",
    carryingCapacity: "Грузоподъёмность",
    carryingCapacitySmall: "грузоподъёмность",
    vehicleType: "Тип ТС",
    arrivalPurpose: "Цель заезда",
    pavilion: "Павильон",
    hall: "Зал",
    stand: "Стенд",
    status: "Статус",
    statusAccepted: "Одобрено",
    statusRejected: "Отклонено",
    statusPending: "На рассмотрении",
    qrCode: "QR-код",

    birthYear: "Год рождения",
    birthYearPlaceholder: "ГГГГ",

    birthplacePlaceholder: "Как в паспорте",

    cargoName: "Наименование груза",
    cargoNamePlaceholder: "Описание",
    cargoQty: "Количество",

    addCargo: "Добавить груз",

    considerationStatus: "На рассмотрении",
    rejectedStatus: "Отклонен",
    downloadRules: "Скачать файлы:",
    entryRules: "Порядок ввоза/вывоза оборудования и экспонатов",
    locationRules:
      "Правила нахождения транспортных средств на территории выставочного комплекса",
    appForms:
      "Формы документов (Доверенность, Письмо для ввоза и вывоза, Письмо на пропуска и др.)",
    warningMessage:
      "Функция печати разового автомобильного пропуска доступна только после проверки введенных данных"
  },

  montage: {
    warningMontagePass:
      "Не забудьте распечатать или сохранить на телефон оформленные пропуска на монтаж/демонтаж! Используйте их для прохода на входных турникетах AO «ЭКСПОЦЕНТР».",
    title: "Пропуск <br /> на монтаж/демонтаж",
    downloadBlank: "/static/pass-template/montage-template.xlsx",
    installationPeriod: "Сроки монтажа: {from} — {to}",
    dismantingPeriod: "Сроки демонтажа: {from} — {to}",

    rulesTitle: "Правила ввоза и вывоза оборудования и экспонатов",
    quotaText:
      'Если Вам необходимо увеличить квоту по пропускам на Монтаж/Демонтаж, обратитесь в ООО "ЭКСПОКОНСТА"  тел. +7 (499) 795-25-36, e-mail: sales@expoconsta.ru',

    addTitle: "Добавить пропуск на монтаж/демонтаж",
    applicationTitle: "Заявка на пропуск",

    birthdayPlaceholder: "ДД.ММ.ГГГГ",
    birthplacePlaceholder: "Как в паспорте",

    packageUploadSize: "xlsx, 10 КБ",
    warningMessage:
      "Функция печати пропусков на монтаж/демонтаж открывается {date}г."
  }
};
